import Vue from 'vue'
import Vuex from 'vuex'
import { IS_PRODUCTION } from './libs/constants'
import { getUserInfo } from '@/api/user'
import { getCurrentNext } from '@/api/userPlan'
import { getNormalizedPlanData } from '@/libs/plan-helper'

Vue.use(Vuex)

const now = new Date()

const store = new Vuex.Store({
  state: {
    errorData: null,
    layout: {
      gnbMinimize: false,
      lnbMinimize: false
    },
    isFirstLogin: false,
    userData: null,
    planData: null
  },
  getters: {

  },
  mutations: {
    setUserData (state, value) {
      state.userData = value
    },
    setPlanData (state, value) {
      state.planData = value
    },
    setErrorData (state, payload) {
      state.errorData = payload
    },
    setLnbMinimize (state) {
      state.layout.lnbMinimize = !state.layout.lnbMinimize
    },
    setGnbMinimize (state) {
      state.layout.gnbMinimize = !state.layout.gnbMinimize
    },
    setIsFirstLogin (state, payload) {
      state.isFirstLogin = payload
    },
    clearAllUserData (state) {
      state.userData = null
      state.planData = null
    }
  },
  actions: {
    storeUserData ({ dispatch, commit }, payload) {
      return getUserInfo(payload).then(data => {
        commit('setUserData', data)
        return data
      })
    },
    storePlanData ({ commit, state }) {
      const handlePlanData = (data) => {
        const planData = getNormalizedPlanData(data)
        commit('setPlanData', planData)
        return planData
      }

      return getCurrentNext().then(data => {
        handlePlanData(data)
        return data
      }).catch(error => {
        if (error.message === 'No Plan found') {
          handlePlanData({})
        } else {
          throw error
        }
      })
    }
  },
  strict: IS_PRODUCTION
})

export default store

export function getStore () {
  return store
}
